import { downloadBlob } from 'utils/preview-export';

export type CsvCellValue = string | number | null | undefined;

export function escapeCsvValue(value: CsvCellValue): string {
  return `"${String(value ?? '').replace(/"/g, '""')}"`;
}

export function exportToCsv(headers: string[], rows: CsvCellValue[][], filename: string): void {
  const headerLine = headers.map(escapeCsvValue).join(',');
  const bodyLines = rows.map(row => row.map(escapeCsvValue).join(','));
  const blob = new Blob([[headerLine, ...bodyLines].join('\n')], { type: 'text/csv' });
  downloadBlob(blob, filename);
}
